import { Navigate } from 'react-router-dom';
import Navigation from "./Navigation.jsx";
import { useParams } from "react-router";
import UserManagement from "./UserManagement.jsx";
import UserGroups from "./UserGroups.jsx";
import LegacyGroups from "./LegacyGroups.jsx";
import LegacyUserManagement from "./LegacyUserManagement.jsx";
import SessionReload from "./component-assets/SessionReload.jsx";
import {compareRole, iAmHigherAuthority} from "../libs.jsx";
import UsersPage from "../pages/users/UsersPage.jsx";
import { usePortalVersion } from '../contexts/PortalVersionContext.jsx';
import { getSession } from "../services/session";

const Users = (props) => {
    const { portalVersion } = usePortalVersion();
    const isV2 = portalVersion === 'v2';

    let pageContent, dData, paramVars, bData;
    paramVars = useParams();

    dData = getSession();

    if (dData.migrated){
        if (paramVars?.dType === "groups"){
            pageContent = isV2 ? <UsersPage initialTab="usergroups" /> : <UserGroups />;
        }else if (paramVars?.dType === "usermanagement"){
            pageContent = isV2 ? <UsersPage initialTab="users" /> : <UserManagement />;
        }else{
            pageContent = isV2 ? <UsersPage initialTab="users" /> : (
                <div>
                    <h3>Page not found. 404</h3>
                </div>
            );
        }
    }else{
        if (paramVars?.dType === "groups"){
            pageContent = <LegacyGroups />;
        }else if (paramVars?.dType === "usermanagement"){
            pageContent = <LegacyUserManagement />
        }else{
            pageContent = (
                <div>
                    <h3>Page not found. 404</h3>
                </div>
            );
        }
    }

    return (compareRole("caregiver", dData?.userrole) || iAmHigherAuthority(10, dData?.role_weight)) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {pageContent}
        </>
    ) : <Navigate to={"/"}/>;
};

export default Users;